// отделить окончание от слова
const getWordParts = (word: string, symbolsAmount: number) => {
  let start = word.substring(0, word.length - symbolsAmount)
  let end = word.substring(word.length - symbolsAmount)
  return { start, end }
}

// Родительный падеж, по кому?\чему?
const getGenitiveForm = (specialty: string) => {
  const exceptionList: { [key: string]: string } = {
    и: 'и',
    питания: 'питания',
    труда: 'труда',
    болезни: 'болезням',
    общая: 'общей',
    здравоохранения: 'здравоохранения',
    здоровье: 'здоровья',
    исследования: 'исследованиям',
    помощь: 'помощи',
    'медицина)': 'медицине)',

    'санитарно-гигиенические': 'санитарно-гигиеническим',
    'анестезиология-реаниматология': 'анестезиологии-реаниматологии',
    'онкология-гематология': 'онкологии-гематологии',
    'урология-андрология': 'урологии-андрологии',
    'психиатрия-наркология': 'психиатрии-наркологии',
    'сурдология-оториноларингология': 'сурдологии-оториноларингологии',
  }

  const rulesList: { [key: string]: string } = {
    ия: 'ии',
    ие: 'ию',
    ая: 'ой',
    ые: 'ым',
    ое: 'ому',
    а: 'е',
    я: 'и',
    о: 'у',
    e: 'ю',
  }
  const words = specialty.split(' ')
  const genWords = words.map((word) => {
    word = word.toLowerCase()

    if (Object.keys(exceptionList).includes(word)) return exceptionList[word]

    let parts = getWordParts(word, 2)
    if (rulesList[parts.end]) return `${parts.start}${rulesList[parts.end]}`

    parts = getWordParts(word, 1)
    if (rulesList[parts.end]) return `${parts.start}${rulesList[parts.end]}`

    return word
  })

  const res = genWords.join(' ')
  return res
}

// бред конечно, проще с бэка это получать
const getDoctorForm = (specialty: string, rule = '') => {
  const exceptionList: { [key: string]: string } = {
    и: 'и',
    генетика: `генетик${rule}`,
    детская: `детских`,
    психотерапия: `психотерапевт${rule}`,
    радиотерапия: `радиотерапевт${rule}`,
    рефлексотерапия: `рефлексотерапевт${rule}`,
    терапия: `терапевт${rule}`,
    фармация: `фармацевт${rule}`,
    фармакология: `фармакология`,
    физиотерапия: `физиотерапевто${rule}`,
    эндоскопия: `эндоскопист${rule}`,
    питания: `питания`,
    биохимия: `биохимия`,
    микробиология: `микробиология`,
    акушерство: `акушер${rule}`,
  }

  const rulesList: { [key: string]: string } = {
    ия: `${rule}`,
  }
  const words = specialty.split(' ')

  const getDoctorWords = (words: string[], delim = ' '): string => {
    return words
      .map((word) => {
        word = word.toLowerCase()

        if (Object.keys(exceptionList).includes(word)) return exceptionList[word]

        if (word.includes('-')) return getDoctorWords(word.split('-'), '-')

        const parts = getWordParts(word, 2)
        if (rulesList[parts.end] != undefined) return `${parts.start}${rulesList[parts.end]}`

        return word
      })
      .join(delim)
  }

  return getDoctorWords(words)
}

export { getGenitiveForm, getDoctorForm }
